import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useApp } from '../contexts/AppContext';
import { ChevronLeftIcon, CameraIcon, ShieldCheckIcon, AwardIcon, ClockIcon } from 'lucide-react';
interface ProfileProps {
  onBack: () => void;
}
export function Profile({
  onBack
}: ProfileProps) {
  const {
    colors
  } = useTheme();
  const {
    user
  } = useApp();
  const [isEditing, setIsEditing] = useState(false);
  return <div className="min-h-screen -m-4" style={{
    backgroundColor: colors.background
  }} data-id="element-316">
      {/* Header */}
      <div className="sticky top-0 z-10 p-4 border-b" style={{
      backgroundColor: colors.cardSurface,
      borderColor: colors.divider
    }} data-id="element-317">
        <div className="flex items-center gap-4" data-id="element-318">
          <button onClick={onBack} className="p-2 -ml-2" style={{
          color: colors.textPrimary
        }} data-id="element-319">
            <ChevronLeftIcon size={24} data-id="element-320" />
          </button>
          <div data-id="element-321">
            <h1 className="text-xl font-bold" style={{
            color: colors.textPrimary
          }} data-id="element-322">
              Profile
            </h1>
            <p className="text-sm" style={{
            color: colors.textSecondary
          }} data-id="element-323">
              Manage your information
            </p>
          </div>
        </div>
      </div>
      <div className="p-4 space-y-4" data-id="element-324">
        {/* Profile Photo */}
        <div className="p-8 rounded-xl flex flex-col items-center" style={{
        backgroundColor: colors.cardSurface
      }} data-id="element-325">
          <div className="relative" data-id="element-326">
            <div className="w-32 h-32 rounded-full flex items-center justify-center text-4xl font-bold" style={{
            backgroundColor: colors.accent,
            color: '#FFFFFF'
          }} data-id="element-327">
              {user?.name.split(' ').map(n => n[0]).join('')}
            </div>
            <button className="absolute bottom-0 right-0 w-10 h-10 rounded-full flex items-center justify-center shadow-lg" style={{
            backgroundColor: colors.cardSurface,
            color: colors.textPrimary
          }} data-id="element-328">
              <CameraIcon size={20} data-id="element-329" />
            </button>
          </div>
        </div>
        {/* Personal Information */}
        <div className="p-6 rounded-xl" style={{
        backgroundColor: colors.cardSurface
      }} data-id="element-330">
          <div className="flex items-center justify-between mb-4" data-id="element-331">
            <h2 className="text-lg font-bold" style={{
            color: colors.textPrimary
          }} data-id="element-332">
              Personal Information
            </h2>
            <button onClick={() => setIsEditing(!isEditing)} className="px-4 py-2 rounded-full font-medium" style={{
            color: colors.accent,
            border: `2px solid ${colors.accent}`
          }} data-id="element-333">
              {isEditing ? 'Save' : 'Edit'}
            </button>
          </div>
          <div className="space-y-4" data-id="element-334">
            <div data-id="element-335">
              <label className="block text-sm font-medium mb-2" style={{
              color: colors.textPrimary
            }} data-id="element-336">
                Full Name
              </label>
              <input type="text" defaultValue={user?.name} disabled={!isEditing} className="w-full p-3 rounded-lg" style={{
              backgroundColor: colors.background,
              color: colors.textPrimary,
              border: `1px solid ${colors.divider}`
            }} data-id="element-337" />
            </div>
            <div data-id="element-338">
              <label className="block text-sm font-medium mb-2" style={{
              color: colors.textPrimary
            }} data-id="element-339">
                Email Address
              </label>
              <input type="email" defaultValue={user?.email} disabled={!isEditing} className="w-full p-3 rounded-lg" style={{
              backgroundColor: colors.background,
              color: colors.textSecondary,
              border: `1px solid ${colors.divider}`
            }} data-id="element-340" />
            </div>
            <div data-id="element-341">
              <label className="block text-sm font-medium mb-2" style={{
              color: colors.textPrimary
            }} data-id="element-342">
                Phone Number
              </label>
              <input type="tel" defaultValue={user?.phone} disabled={!isEditing} className="w-full p-3 rounded-lg" style={{
              backgroundColor: colors.background,
              color: colors.textSecondary,
              border: `1px solid ${colors.divider}`
            }} data-id="element-343" />
            </div>
            <div data-id="element-344">
              <label className="block text-sm font-medium mb-2" style={{
              color: colors.textPrimary
            }} data-id="element-345">
                Employee ID
              </label>
              <input type="text" defaultValue={user?.employeeId} disabled className="w-full p-3 rounded-lg" style={{
              backgroundColor: colors.background,
              color: colors.textSecondary,
              border: `1px solid ${colors.divider}`
            }} data-id="element-346" />
            </div>
          </div>
        </div>
        {/* Your Stats */}
        <div className="p-6 rounded-xl" style={{
        backgroundColor: colors.cardSurface
      }} data-id="element-347">
          <h2 className="text-lg font-bold mb-4" style={{
          color: colors.textPrimary
        }} data-id="element-348">
            Your Stats
          </h2>
          <div className="grid grid-cols-3 gap-4" data-id="element-349">
            <div className="text-center" data-id="element-350">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-2" style={{
              backgroundColor: colors.accent + '20'
            }} data-id="element-351">
                <ShieldCheckIcon size={24} style={{
                color: colors.accent
              }} data-id="element-352" />
              </div>
              <div className="text-2xl font-bold mb-1" style={{
              color: colors.textPrimary
            }} data-id="element-353">
                97%
              </div>
              <div className="text-sm" style={{
              color: colors.textSecondary
            }} data-id="element-354">
                Compliance
              </div>
            </div>
            <div className="text-center" data-id="element-355">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-2" style={{
              backgroundColor: colors.success + '20'
            }} data-id="element-356">
                <AwardIcon size={24} style={{
                color: colors.success
              }} data-id="element-357" />
              </div>
              <div className="text-2xl font-bold mb-1" style={{
              color: colors.textPrimary
            }} data-id="element-358">
                156
              </div>
              <div className="text-sm" style={{
              color: colors.textSecondary
            }} data-id="element-359">
                Completed
              </div>
            </div>
            <div className="text-center" data-id="element-360">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-2" style={{
              backgroundColor: colors.warning + '20'
            }} data-id="element-361">
                <ClockIcon size={24} style={{
                color: colors.warning
              }} data-id="element-362" />
              </div>
              <div className="text-2xl font-bold mb-1" style={{
              color: colors.textPrimary
            }} data-id="element-363">
                3.8
              </div>
              <div className="text-sm" style={{
              color: colors.textSecondary
            }} data-id="element-364">
                Avg Time
              </div>
            </div>
          </div>
        </div>
        {/* Security */}
        <div className="p-6 rounded-xl" style={{
        backgroundColor: colors.cardSurface
      }} data-id="element-365">
          <h2 className="text-lg font-bold mb-4" style={{
          color: colors.textPrimary
        }} data-id="element-366">
            Security
          </h2>
          <button className="w-full p-4 rounded-full font-medium" style={{
          color: colors.accent,
          border: `2px solid ${colors.accent}`
        }} data-id="element-367">
            Change Password
          </button>
        </div>
      </div>
    </div>;
}